import { render } from "./Collections.vue?vue&type=template&id=a57801d4&scoped=true"
import script from "./Collections.vue?vue&type=script&lang=js"
export * from "./Collections.vue?vue&type=script&lang=js"

import "./Collections.vue?vue&type=style&index=0&id=a57801d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57801d4"]])

export default __exports__